import { render, staticRenderFns } from "./gift_package_add.vue?vue&type=template&id=6ea013ac"
import script from "./gift_package_add.vue?vue&type=script&lang=js"
export * from "./gift_package_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports